export default __webpack_public_path__ + "static/media/Cargo2.303ef507.png";